import { createContext, useContext } from 'react';

interface EscalateFills {
  control: string;
  badge: string;
}

const PANEL_FILLS: EscalateFills = {
  control: 'bg-white dark:bg-ondark-bg-3',
  badge: 'bg-white dark:bg-ondark-line-3',
};

export const CARD_FILLS: EscalateFills = {
  control: 'bg-white dark:bg-dark-bg',
  badge: 'bg-white dark:bg-dark-bg',
};

export const EscalateFillsContext = createContext(PANEL_FILLS);

export function useEscalateFills(): EscalateFills {
  return useContext(EscalateFillsContext);
}
